module.exports = __webpack_public_path__ + "img/face_shape_female_rect_mask.b2e3eb5c.png";